import isSignedPixelData from './isSignedPixelData.js';
export default function getPixelData(frameInfo, decodedBuffer, signedOverride) {
    const signed = isSignedPixelData({
        isSigned: signedOverride ?? frameInfo?.isSigned,
        componentCount: frameInfo?.componentCount,
    });
    if (frameInfo?.bitsPerSample > 8) {
        if (signed) {
            return new Int16Array(decodedBuffer.buffer, decodedBuffer.byteOffset, decodedBuffer.byteLength / 2);
        }
        return new Uint16Array(decodedBuffer.buffer, decodedBuffer.byteOffset, decodedBuffer.byteLength / 2);
    }
    if (signed) {
        return new Int8Array(decodedBuffer.buffer, decodedBuffer.byteOffset, decodedBuffer.byteLength);
    }
    return new Uint8Array(decodedBuffer.buffer, decodedBuffer.byteOffset, decodedBuffer.byteLength);
}
